import useWithUserAndTenant from 'src/use-with-user-and-tenant';
import {isFreemiumPracticeManagementLicense} from './licenses.helper';

// DEPRECATED ===============================================
// Use `contact-limit-model.hooks.js` instead
export function useIsFreemiumPracticeManagement() {
  const [user, tenant] = useWithUserAndTenant();
  return tenant ? isFreemiumPracticeManagementLicense('practiceManagement', tenant.contact_limit) : null; // if tenant is null, return null
}
// ==========================================================